import React, { useState, useContext, useEffect } from 'react';
import { ContextProvider } from '../globalContextProvider';
import {Button} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import config from '../config.json';
import { getTutorials } from '../sharedData';
import circularBg from '../images/circularBg.png'

const CustomTutorialTour = () => {
    const { isActive, setIsActive, currentPathName } = useContext(ContextProvider);
    const [currentStep, setCurrentStep] = useState(0);
    
    const tutorials = getTutorials();
    const steps = tutorials[currentPathName] && tutorials[currentPathName]["steps"] ? tutorials[currentPathName]["steps"].filter((step) => step.visible === true) : null;
    
    const skipTour = () => {
        setIsActive(false);
        setCurrentStep(0);
    };

    const backStep = () => {
        if (currentStep > 0) {
            setCurrentStep((prevStep) => prevStep - 1);
        }
    };

    const nextStep = () => {
        if (currentStep < steps.length - 1) {
            setCurrentStep((prevStep) => prevStep + 1);
        } else {
            setIsActive(false);
            setCurrentStep(0);
        }
    };

    const updateOnboardDetails = () => {
        const requestBody = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ location: ``, society_onboard_tour: 1 })
        };

        fetch(`${config.HOST_NAME}/crm/v3/updateCrmUser/loginDetails`, requestBody)
            .then((res) => res.json())
            .then((res) => {
                if (res.success) sessionStorage.setItem('society_onboard_tour', 1)
            })
            .catch((error) => console.log(error))
    }

    useEffect(() => {
        const duplicateSourceElements = document.querySelectorAll('[id^="duplicateSourceElementId-"]');
        if (duplicateSourceElements && duplicateSourceElements[0]) {
            duplicateSourceElements.forEach((element) => {
                if (element.id.startsWith('duplicateSourceElementId-')) {
                    element.parentNode.removeChild(element);
                }
            });
        }
        if (isActive && currentStep < steps.length) {

            if(sessionStorage.getItem('society_onboard_tour') === "0" && sessionStorage.getItem('role') === 'contractor' && sessionStorage.getItem('show_rfid') === "1"){
                updateOnboardDetails()  
            }

            const allSourceElements = document.querySelectorAll('.source-element');
            allSourceElements.forEach((sourceElement) => {
                sourceElement.style.outline = '';
            });

            const sourceElement = document.getElementById(
                steps[currentStep].targetClass
            );

            if(sourceElement){
                const sourceRect = sourceElement.getBoundingClientRect();
            const sourceTop = sourceRect.top;
            const sourceLeft = sourceRect.left ? sourceRect.left : 0;
            const sourceHeight = sourceRect.height;
            const sourceWidth = sourceRect.width;

            const targetElement = document.getElementById('custom-tour-div');
            targetElement.style.position = 'absolute';
            targetElement.style.top = sourceTop + sourceHeight + 10 + 'px';
            targetElement.style.left = sourceLeft + 'px';
            targetElement.style.zIndex = '9999';

            const duplicateSourceElement = sourceElement.cloneNode(true);
            const computedStyles = window.getComputedStyle(sourceElement);
            for (const property of computedStyles) {
              duplicateSourceElement.style[property] = computedStyles.getPropertyValue(property);
            }
            duplicateSourceElement.id = `duplicateSourceElementId-${currentStep}`;
            duplicateSourceElement.style.position = 'absolute';
            duplicateSourceElement.style.top = sourceTop + 'px';
            duplicateSourceElement.style.left = sourceLeft + 'px';
            duplicateSourceElement.style.width = sourceWidth + 'px';
            duplicateSourceElement.style.height = sourceHeight + 'px';
            duplicateSourceElement.style.zIndex = '9999';
            duplicateSourceElement.style.backgroundColor = '#FFF';

            const tourContentElement = document.querySelector('.tour-content');
            tourContentElement.parentNode.insertBefore(duplicateSourceElement, tourContentElement);

            const circularBg = document.getElementById('circular-bg');
            circularBg.style.width = '475px';
            circularBg.style.position = 'absolute';
            circularBg.style.top = sourceRect.top - 140 + 'px';
            circularBg.style.left = sourceRect.left ? sourceRect.left : -200 + 'px';
            }
        }
    }, [currentStep, isActive]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!steps) return null;
    
    return (
        <div>
            {isActive && (
                <div className="tour-overlay">
                    <div id="custom-tour-div" className="tour-content">

                        <div style={{ fontSize: 12, fontWeight: 'bold', color: '#334D6E' }}>{steps[currentStep] ? steps[currentStep].title : ""} </div>
                        <p style={{ fontSize: 12, color: '#334D6E', maxWidth: 250 }}>{steps[currentStep] ? steps[currentStep].content : ""}</p>

                        <div style={{ display: 'flex', justifyContent: "flex-end", alignItems: "flex-end", marginTop: 30, columnGap: 5 }}>
                            <Button
                                color="primary"
                                variant="contained"
                                style={{ textTransform: "none", fontSize: 10, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "35px", backgroundColor: currentStep === 0 ? "#C2CFE0" : "#334D6E", color: "#FFF" }}
                                disableElevation
                                onClick={backStep}
                                disabled={currentStep === 0}
                            >
                                <ArrowBackIcon style={{ fontSize: 18 }} />
                            </Button>

                            <Button
                                color="primary"
                                variant="contained"
                                style={{ textTransform: "none", fontSize: 10, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "35px", backgroundColor: "#18CC69", color: "#FFF" }}
                                disableElevation
                                onClick={nextStep}
                            >
                                {currentStep === steps.length - 1 ? 'Finish' : 'Next'}
                                <ArrowForwardIcon style={{ fontSize: 18, marginLeft: 5 }} />
                            </Button>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 10, right: 10, textTransform: "none", width: 23, height: 23, backgroundColor: "#de575e", color: "#FFF", borderRadius: 100, cursor: "pointer" }}
                            onClick={skipTour}
                        >
                            <CloseIcon style={{ fontSize: 16 }} />
                        </div>
                    </div>
                    <div id='circular-bg'>
                        <img src={circularBg} style={{width:"100%"}} alt='circular bg' />
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomTutorialTour;